import { getAverageRGBfromImage } from "../utilities/color";
import { fileUploadToImage } from "../utilities/file";

export class FileUploaderModule {
  initialize() {
    this.fileUploaderElements = document.querySelectorAll(".file-uploader");

    if (!this.fileUploaderElements) return;

    this.fileUploaderElements.forEach((fileUploaderElement) => {
      new FileUploader(fileUploaderElement);
    });
  }
}

class FileUploader {
  constructor(fileUploaderElement) {
    this.fileUploaderElement = fileUploaderElement;

    this.addEventListeners();
  }

  // Element getters
  get fileInputElement() {
    return this.fileUploaderElement.querySelector(".file-uploader-input");
  }

  get buttonElement() {
    return this.fileUploaderElement.querySelector(".file-uploader-button");
  }

  get previewContainer() {
    return this.fileUploaderElement.querySelector(".file-uploader-preview");
  }

  get previewIcon() {
    return this.fileUploaderElement.querySelector(
      ".file-uploader-preview-icon"
    );
  }

  get messageElement() {
    return this.fileUploaderElement.querySelector(".file-uploader-message");
  }

  // State getters/setters
  get selectedImage() {
    return this._selectedImage;
  }

  set selectedImage(value) {
    this._selectedImage = value;
    if (value === null) {
      this.fileInputElement.value = null;
    }
    this.render();
  }

  get message() {
    return this.messageElement.innerHTML;
  }

  set message(value) {
    this.messageElement.innerHTML = value;
  }

  // Event listeners
  addEventListeners() {
    this.buttonElement.addEventListener("click", this.onButtonClick.bind(this));
    this.fileInputElement.addEventListener(
      "change",
      this.onFileInputChange.bind(this)
    );
  }

  onButtonClick(e) {
    e.preventDefault();
    this.fileInputElement.click();
  }

  onFileInputChange(e) {
    if (!e.target.files.length) return;

    this.selectedImage = e.target.files[0];
  }

  // Render methods
  async render() {
    this.setPreviewImage();
    this.setMessage();
    
    if (!this.selectedImage) return;
    await this.setAverageImageColor();
  }

  async setAverageImageColor() {
    // Get the average color of the image
    const imageFromFile = await fileUploadToImage(this.selectedImage);
    let averageColor = getAverageRGBfromImage(imageFromFile);

    // Increase the color intensity
    averageColor.r = Math.min(255, averageColor.r * 1.2);
    averageColor.g = Math.min(255, averageColor.g * 1.2);
    averageColor.b = Math.min(255, averageColor.b * 1.2);

    // Set the average color as a CSS variable, which will be used for the glow in animation
    this.previewContainer.style.setProperty(
      "--average-color",
      `${averageColor.r}, ${averageColor.g}, ${averageColor.b}`
    );
  }

  setPreviewImage() {
    // Remove any existing image
    this.previewContainer
    .querySelectorAll(".file-uploader-preview-image")
    .forEach((imgElement) => {
      imgElement.remove();
    });

    if (this.selectedImage) {
      // Hide the placeholder icon
      this.previewIcon.classList.add("d-none");

      // Create a new image element and append it to the preview container, for the user to see the selected image
      const imgElement = document.createElement("img");
      imgElement.src = URL.createObjectURL(this.selectedImage);
      imgElement.classList.add("file-uploader-preview-image");
      this.previewContainer.appendChild(imgElement);
    } else {
      // If no image is selected, show the placeholder icon
      this.previewIcon.classList.remove("d-none");
    }
  }

  setMessage() {
    if (this.selectedImage) {
      this.message = 
      `
        <button class="d-flex align-items-center border-0 bg-transparent">
          Gekozen afbeelding: ${this.selectedImage.name} 
          <svg class="icon-15 icon-gray-100 ms-2" style="width: 15px;">
            <use xlink:href="#icon-trash"></use>
          </svg>
        </button>
      `;

      this.messageElement.addEventListener("click", () => {
        this.selectedImage = null;
      });
    } else {
      this.message = "Nog geen foto gekozen";
    }
  }
}
